import React, { useState, useCallback, useEffect, forwardRef } from 'react';

import styles from './styles.module.scss';
import { useContext } from 'react';
import { AdminContext } from '../../context/AdminContext';
import Avatar from '../Avatar';
import blanckUser from '../../../../assets/imgs/blank-profile-picture.png';
import blankGroup from '../../../../assets/imgs/blank-group-picture.png';
import Button from '../Button';
import CenterModal from '../CenterModal';
import ChatFooter from '../OnlineChat/ChatFooter';
import Api from '../../api';

const ChannelPageCardMobile = forwardRef((props, ref) => {
  const {
    login,
    setTrigger,
    themeColor,
    privateUsers,
    setUserChannelId,
    setShowSearch,
    showFirstMessage,
    setShowFirstMessage,
    userChannelId,
    setActiveUser,
    activeUser,
    videoChatSize,
    sharedUserClicked,
    setSharedUserClicked,
  } = useContext(AdminContext);

  const [follower, setFollower] = useState(props?.followNum);
  const [follow, setFollow] = useState(props?.isFollow);
  const [showMoreText, setShowMoreText] = useState(false);
  const [showText, setShowText] = useState(false);
  const [previousChannelId, setPreviousChannelId] = useState('');
  // const [message, setMessage] = useState('');
  // const [dragActive, setDragActive] = useState(false);

  console.log('item', props?.item);
  const startChatFunction = (y) => {
    console.log('sssss', privateUsers, y.uuid, y);
    let index = privateUsers.findIndex(
      (x) => x?.users?.[0]?.channelUser?.uuid == y.uuid
    );
    if (index == -1) {
      // if (activeUser?.users?.[0]?.channelUser?.channelId != userChannelId) {
      //   Api.privateChatUsersChat()
      //   .then((res) => {
      //     setActiveUser(
      //       data?.response?.filter(
      //         (x) => x?.users?.[0]?.channelUser?.channelId == userChannelId
      //       )?.[0]
      //     );
      //     // setPrivateUsers(res?.data?.response);
      //     // setloadingUsers(false);
      //     // setUserChannelId(
      //     //   res?.data?.response?.[0]?.users?.[0]?.channelUser?.channelId
      //     // );
      //     // setActiveUser(res?.data?.response?.[0]);
      //   })
      //   .catch((err) => {});

      // }
      setShowFirstMessage(y?.uuid);
      setPreviousChannelId(userChannelId);
      setUserChannelId(y?.uuid);
      setSharedUserClicked(y?.channelName);
    } else {
      setUserChannelId(y?.uuid);
      setShowSearch(false);
    }
  };

  return (
    <>
      <div
        className={`${styles.container}${` `}${
          props?.className
        } relative cursor-pointer`}
        onClick={() => startChatFunction(props?.item)}
      >
        <div
          className={`flex flex-row justify-between items-center h-auto w-auto my-[5px] ${`userBoxStyle`} relative `}
        >
          <div className={`flex flex-row justify-start items-center `}>
            <Avatar
              width={34}
              height={34}
              containerclass={` relative roundBox `}
              className={``}
              src={
                props?.item?.image?.name
                  ? props?.item?.image?.name
                  : props?.item?.typeId == 2
                  ? blankGroup
                  : blanckUser
              }
              local={!props?.item?.image?.name}
            ></Avatar>
            <p className={`text-right `}>
              {props?.item?.channelName
                ? props?.item?.channelName
                : props?.item?.username}
            </p>
            {/* <Button
              className={` sendBtn flex flex-row justify-center items-center mr-auto`}
              onClick={() => startChatFunction(props?.item)}
            >
              {props?.content?.conversation}
            </Button> */}
          </div>
        </div>
      </div>
      {showFirstMessage == props?.item?.uuid && (
        <CenterModal
          handleShowModal={() => {
            setShowFirstMessage('');
            setUserChannelId(previousChannelId);
            setShowSearch(true);
            setSharedUserClicked();
          }}
          extraContentStyle={`firstMessageModal modalContent`}
        >
          <div className={`${styles.inputContainerModal}`}>
            <p>{`${props?.content?.startConversationTo}   : ${sharedUserClicked}`}</p>
            <ChatFooter
              ref={ref}
              setServerError={props?.setServerError}
              fileType={props?.fileType}
              loadingFile={props?.loadingFile}
              setLoadingFile={props?.setLoadingFile}
              loadingFileButton={props?.loadingFileButton}
              setLoadingFileButton={props?.setLoadingFileButton}
              setLoadingOldMessages={props?.setLoadingOldMessages}
              setTypingStatus={props?.setTypingStatus}
              users={props?.users}
              chatTypePrivate={props?.chatTypePrivate}
              replyValue={props?.replyValue}
              setReplyValue={props?.setReplyValue}
              content={props?.content}
              setMessages={props?.setMessages}
              fromSearch={true}
              handleSendMessage={props?.handleSendMessage}
              sendFunction={props?.sendFunction}
              notTyping={props?.notTyping}
              message={props?.message}
              setMessage={props?.setMessage}
              sendFunction={props?.sendFunction}
              notTyping={props?.notTyping}
              message={props?.message}
              setMessage={props?.setMessage}
              extraFooterStyle={`relativeFooter`}
              showFirstMessage={showFirstMessage}
              sendContact={props?.sendContact}

              // dragActive={dragActive}
            />
          </div>
        </CenterModal>
      )}
    </>
  );
});

export default ChannelPageCardMobile;
